import { ReactNode } from 'react'
import { Box, LinearProgress, Typography } from '@mui/material'
import { WALTER_COLORS } from '../../utils/artDirection'

type MarketplaceHeroPropsType = {
  /** Aplat noir côté Learning, blanc cassé côté Santé, comme sur les sites vitrines. */
  onDark: boolean
  title: string
  subtitle: ReactNode
  selectedCount: number
  target: number
  children?: ReactNode
}

/** Hero des deux marketplaces : aplat, titre en serif de titrage, progression du panier. Aucun
 * dégradé ni ombre, cf. docs/direction-artistique.md. */
const MarketplaceHero = ({ onDark, title, subtitle, selectedCount, target, children }: MarketplaceHeroPropsType) => (
  <Box
    sx={{
      p: { xs: 3, md: 5 },
      mb: 5,
      borderRadius: 3,
      backgroundColor: onDark ? WALTER_COLORS.black : WALTER_COLORS.mastic,
      color: onDark ? 'common.white' : 'text.primary',
    }}
  >
    <Typography variant="h3" sx={{ maxWidth: 620 }}>
      {title}
    </Typography>
    {/* `color: inherit` est nécessaire : le thème fixe une couleur noire sur body1, qui rendrait le
        paragraphe invisible sur l'aplat noir du hero Learning. */}
    <Typography variant="body1" sx={{ mt: 2, maxWidth: 620, color: 'inherit', opacity: 0.8 }}>
      {subtitle}
    </Typography>
    {children}
    <Box sx={{ mt: 4, maxWidth: 420 }}>
      <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
        {`${selectedCount} sur ${target} formations sélectionnées`}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={Math.min((selectedCount / target) * 100, 100)}
        sx={{
          height: 8,
          backgroundColor: onDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.12)',
          '& .MuiLinearProgress-bar': { backgroundColor: 'primary.main' },
        }}
      />
    </Box>
  </Box>
)

export default MarketplaceHero
